/* Guida pali in carbonio: prezzi letti dai prodotti Shopify, kit a due pali, configuratore e carrello col codice. */
(function () {
  var root = document.querySelector('[data-apc]'); if (!root) return;
  var dati = JSON.parse(document.getElementById('apc-dati').textContent);
  var CODICE = root.dataset.codice, SC = (parseFloat(root.dataset.sconto) || 0) / 100;
  var V = {};   // codice articolo -> variante
  dati.forEach(function (p) { p.v.forEach(function (v) { var c = (v.sku || '').split('_').pop(); if (c && !V[c]) V[c] = { id: v.id, p: v.p / 100, ok: v.ok }; }); });
  function E(n) { var s = n.toFixed(2).split('.'); return '€' + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + s[1]; }
  function prezzo(c) { return V[c] ? V[c].p : null; }

  // prezzi "da" sulle schede
  root.querySelectorAll('[data-apc-da]').forEach(function (el) {
    var ps = el.dataset.apcDa.split(',').filter(function (c) { return V[c] && V[c].ok; }).map(prezzo);
    if (ps.length) el.lastElementChild.textContent = E(Math.min.apply(null, ps)); else el.hidden = true;
  });

  // tabella pali fissi
  var FISSI = [['46.816.02', 38, 130, '34.358.38', '46.812.00'], ['46.816.04', 38, 150, '34.358.38', '46.812.00'], ['46.816.06', 38, 170, '34.358.38', '46.812.00'],
    ['46.816.07', 38, 185, '34.358.38', '46.812.01'], ['46.816.08', 38, 200, '34.358.38', '46.812.01'], ['46.816.10', 38, 230, '34.358.38', '46.812.01'],
    ['46.821.02', 50, 170, '34.358.50', ''], ['46.821.04', 50, 200, '34.358.50', ''], ['46.821.06', 50, 230, '34.358.50', '']];
  var tb = root.querySelector('[data-apc-tabella]');
  if (tb) tb.innerHTML = FISSI.filter(function (r) { return V[r[0]]; }).map(function (r) {
    return '<tr><td><code>' + r[0] + '</code></td><td class="n">' + r[1] + ' mm</td><td class="n">' + r[2] + ' cm</td><td>' + r[3] + '</td><td>' + (r[4] || '–') + '</td><td class="n">' + (V[r[0]].ok ? E(prezzo(r[0])) : 'non disponibile') + '</td></tr>';
  }).join('');

  // catalogo del configuratore
  var PALI = [
    ['46.816.02', 'Fisso Ø 38 · 130 cm', 38, 'f', '46.812.00'], ['46.816.04', 'Fisso Ø 38 · 150 cm', 38, 'f', '46.812.00'], ['46.816.06', 'Fisso Ø 38 · 170 cm', 38, 'f', '46.812.00'],
    ['46.816.07', 'Fisso Ø 38 · 185 cm', 38, 'f', '46.812.01'], ['46.816.08', 'Fisso Ø 38 · 200 cm', 38, 'f', '46.812.01'], ['46.816.10', 'Fisso Ø 38 · 230 cm', 38, 'f', '46.812.01'],
    ['46.821.02', 'Fisso Ø 50 · 170 cm', 50, 'f', ''], ['46.821.04', 'Fisso Ø 50 · 200 cm', 50, 'f', ''], ['46.821.06', 'Fisso Ø 50 · 230 cm', 50, 'f', ''],
    ['46.818.09', 'Smontabile Ø 38 · 90+90 cm', 38, 's', ''], ['46.818.11', 'Smontabile Ø 38 · 110+110 cm', 38, 's', '']].filter(function (p) { return V[p[0]] && V[p[0]].ok; });
  var ATT = [
    ['46.815.00', 'Boccola incasso rotante dritta', 38, 'fs'], ['46.815.01', 'Boccola incasso rotante inclinata 6°', 38, 'fs'],
    ['46.814.00', 'Boccola incasso a cerniera dritta', 38, 'f'], ['46.814.01', 'Boccola incasso a cerniera inclinata 6°', 38, 'f'],
    ['46.815.10', 'Kit boccole da parete', 38, 'fs'], ['46.815.12', 'Kit boccole da candeliere', 38, 'f'],
    ['46.820.00', 'Boccola incasso rotante dritta Ø 50', 50, 'f'], ['46.820.01', 'Boccola incasso rotante inclinata 6° Ø 50', 50, 'f'],
    ['46.819.01', 'Boccola incasso a cerniera inclinata 6° Ø 50', 50, 'f']].filter(function (a) { return V[a[0]] && V[a[0]].ok; });
  function ok(c) { return V[c] && V[c].ok; }
  var CIMA = '46.817.00', CLIP = { 38: '34.358.38', 50: '34.358.50' };

  function righe(pal, att, cima, sacca, clip) {
    var r = [[2, 'Palo ' + pal[1].replace(' · ', ', ').toLowerCase(), pal[0]], [2, att[1], att[0]]];
    if (cima && ok(CIMA)) r.push([2, 'Cima Marlow 130 cm', CIMA]);
    if (sacca && pal[4] && ok(pal[4])) r.push([1, 'Sacca per due pali', pal[4]]);
    if (clip && ok(CLIP[pal[2]])) r.push([2, 'Clip a parete Ø ' + pal[2], CLIP[pal[2]]]);
    return r;
  }
  // sconto come lo calcola Shopify: per pezzo, arrotondato per difetto al centesimo
  function scontoRighe(r) { return r.reduce(function (s, x) { return s + x[0] * Math.floor(prezzo(x[2]) * SC * 100 + 1e-6) / 100; }, 0); }
  function htmlRighe(r) {
    var t = 0, h = r.map(function (x) { var v = x[0] * prezzo(x[2]); t += v; return '<li><span>' + x[0] + ' × ' + x[1] + ' <code>' + x[2] + '</code></span><span>' + E(v) + '</span></li>'; }).join('');
    return { html: h, tot: t };
  }

  // kit pronti
  var KIT = [['In coperta', 'Coppia Ø 38 su boccole a filo', 'Il kit più richiesto: prendisole di prua o di poppa su coperta piana.', '46.816.04', '46.815.00', 1, 0],
    ['Senza forare', 'Coppia Ø 38 sui candelieri', 'Per chi non vuole fare buchi in coperta.', '46.816.04', '46.815.12', 1, 0],
    ['Poco spazio', 'Coppia smontabile a parete', 'Pali da 231 cm che si dividono in due per un gavone corto.', '46.818.11', '46.815.10', 0, 0],
    ['Teli grandi', 'Coppia Ø 50 su boccole a filo', 'Diametro maggiore e boccole dedicate, per teli ampi e pali alti.', '46.821.04', '46.820.00', 0, 1]];
  var box = root.querySelector('[data-apc-kits]');
  if (box) box.innerHTML = KIT.map(function (k, i) {
    var pal = PALI.filter(function (p) { return p[0] === k[3]; })[0], att = ATT.filter(function (a) { return a[0] === k[4]; })[0];
    if (!pal || !att) return '';
    var r = htmlRighe(righe(pal, att, true, k[5], k[6]));
    return '<div class="apc-kt"><span class="apc-badge">' + k[0] + '</span><h3>' + k[1] + '</h3><p>' + k[2] + '</p><ul>' + r.html + '</ul>' +
      '<div class="apc-tot apc-tot--pieno"><span>Prezzo pieno</span><span>' + E(r.tot) + '</span></div>' +
      '<div class="apc-tot"><span>Con ' + CODICE + '</span><span>' + E(r.tot - scontoRighe(righe(pal, att, true, k[5], k[6]))) + '</span></div>' +
      '<button type="button" class="apc-btn" data-apc-kit="' + i + '">Aggiungi il kit al carrello</button></div>';
  }).join('');

  // configuratore
  var sp = document.getElementById('apc-palo'), sa = document.getElementById('apc-att');
  if (!sp) return;
  sp.innerHTML = PALI.map(function (p) { return '<option value="' + p[0] + '">' + p[1] + '</option>'; }).join('');
  if (V['46.816.04']) sp.value = '46.816.04';
  function pal() { return PALI.filter(function (p) { return p[0] === sp.value; })[0]; }
  function att() { return ATT.filter(function (a) { return a[0] === sa.value; })[0]; }
  function fillAtt() {
    var p = pal(), cur = sa.value, ok = ATT.filter(function (a) { return a[2] === p[2] && a[3].indexOf(p[3]) >= 0; });
    sa.innerHTML = ok.map(function (a) { return '<option value="' + a[0] + '">' + a[1] + '</option>'; }).join('');
    if (ok.some(function (a) { return a[0] === cur; })) sa.value = cur;
  }
  var correnti = [];
  function draw() {
    var p = pal(), a = att(); if (!p || !a) return;
    document.getElementById('apc-sacca-l').hidden = !(p[4] && ok(p[4]));
    document.getElementById('apc-clip').parentNode.hidden = !ok(CLIP[p[2]]);
    document.getElementById('apc-cima').parentNode.hidden = !ok(CIMA);
    if (p[4]) document.getElementById('apc-sacca-t').textContent = 'Sacca per due pali (' + p[4] + ')';
    document.getElementById('apc-clip-t').textContent = '2 clip a parete Ø ' + p[2];
    correnti = righe(p, a, document.getElementById('apc-cima').checked, document.getElementById('apc-sacca').checked, document.getElementById('apc-clip').checked);
    var r = htmlRighe(correnti), sc = scontoRighe(correnti);
    document.getElementById('apc-list').innerHTML = r.html + (SC ? '<li class="apc-sc"><span>Codice ' + CODICE + ', ' + Math.round(SC * 100) + '% sul kit</span><span>−' + E(sc) + '</span></li>' : '');
    document.getElementById('apc-tot').textContent = E(r.tot - sc);
    document.getElementById('apc-pieno').textContent = 'invece di ' + E(r.tot);
    var n = []; if (p[3] === 's') n.push('Il palo smontabile va nelle boccole rotanti da incasso o nel kit da parete.'); if (p[2] === 50) n.push('Per il Ø 50 esistono solo boccole da incasso dedicate.');
    document.getElementById('apc-msg').textContent = n.join(' ');
  }
  sp.addEventListener('change', function () { fillAtt(); draw(); }); sa.addEventListener('change', draw);
  ['apc-cima', 'apc-sacca', 'apc-clip'].forEach(function (i) { document.getElementById(i).addEventListener('change', draw); });
  fillAtt(); draw();

  // carrello: aggiunge i pezzi e applica il codice
  function carrello(r, btn) {
    var items = r.map(function (x) { return { id: V[x[2]].id, quantity: x[0] }; });
    btn.disabled = true; var t = btn.textContent; btn.textContent = 'Aggiungo…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (res) { if (!res.ok) throw new Error(); location.href = '/discount/' + encodeURIComponent(CODICE) + '?redirect=/cart'; })
      .catch(function () { btn.disabled = false; btn.textContent = t; var m = document.getElementById('apc-msg'); if (m) m.textContent = 'Un pezzo non è disponibile in questo momento: scrivimi e ti dico i tempi.'; });
  }
  document.getElementById('apc-carrello').addEventListener('click', function (e) { carrello(correnti, e.currentTarget); });
  root.querySelectorAll('[data-apc-kit]').forEach(function (b) {
    b.addEventListener('click', function () {
      var k = KIT[+b.dataset.apcKit], p = PALI.filter(function (x) { return x[0] === k[3]; })[0], a = ATT.filter(function (x) { return x[0] === k[4]; })[0];
      carrello(righe(p, a, true, k[5], k[6]), b);
    });
  });
})();
